export const CRYPTO_ERROR_CODES = [
    "invalid-input",
    "invalid-key-length",
    "invalid-nonce-length",
    "decrypt-failed",
    "kdf-failed"
];
export function isCryptoErrorCode(value) {
    if (typeof value !== "string") {
        return false;
    }
    return CRYPTO_ERROR_CODES.some((code) => code === value);
}
export class CryptoError extends Error {
    code;
    constructor(code, message) {
        super(message);
        this.name = "CryptoError";
        this.code = code;
    }
    toJSON() {
        return { name: this.name, code: this.code, message: this.message };
    }
}
//# sourceMappingURL=errors.js.map